import { ResourcePoolImpl } from './ResourcePoolImpl';
import { SceneResource } from './SceneResource';
import { SceneDescription } from './SceneDescription';

export class SceneResourcePool extends ResourcePoolImpl<SceneResource, SceneDescription> {
  createResource(resoruceId: string): SceneResource {
    return new SceneResource(resoruceId);
  }

  loadData(data: string): SceneDescription {
    return new SceneDescription(data);
  }
}
